import { Text as DSText } from '@cash-me/react-components'
import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space } = theme

export const Text = styled(DSText)`
  @media (${media.tablet}) {
    margin-top: ${space['spacing-mega']};
  }
`
